import { JsonObject } from 'json2typescript';
import { CodeTextModel } from 'humanresources-common-shared';

@JsonObject('KovanHrPerObjectModel')
export class PerObjectModel extends CodeTextModel {}
